import React from 'react';
import { MenuSectionType } from 'types/graphql';
import { v4 as uuid } from 'uuid';
import { ImageBannerModal } from '../../image-banner/image-banner-modal';
import { AddCollectionModalProps } from './add-collection-modal/add-collection-modal.types';

export default function AddImageSection({
  handleAddSection,
  menuSection,
  onToggle,
}: AddCollectionModalProps): JSX.Element {
  return (
    <ImageBannerModal
      onClose={onToggle}
      isOpen
      addBanner={(image) => {
        handleAddSection({
          ...menuSection,
          count: menuSection?.count ?? 1,
          id: menuSection?.id ?? uuid(),
          image,
          label: image.alt ?? '',
          position: menuSection?.position ?? 0,
          sectionType: MenuSectionType.image,
        });
      }}
      bannerToEdit={menuSection?.image ?? null}
    />
  );
}
